import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { IpInfoModule } from '@zerops/zui/ip-info';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZuiDocsTextModule } from '@zerops/zui/docs-text';
import { IpInfoCardComponent } from './ip-info-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { SharedIpv4Container } from '@zerops/zerops/feature/shared-ipv4/shared-ipv4.container';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';

@NgModule({
  declarations: [ IpInfoCardComponent ],
  imports: [
    CommonModule,
    MatCardModule,
    IpInfoModule,
    ZefCopyToClipboardModule,
    ZuiDocsTextModule,
    MatIconModule,
    MatButtonToggleModule,
    MatLegacyButtonModule,
    SharedIpv4Container,
    ZuiSeparatorComponent,
    ZefProgressErrorModule,
  ],
  exports: [ IpInfoCardComponent ],
})
export class ZuiIpInfoCardModule { }
